import React, { useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Button, Modal, Nav } from "react-bootstrap";
import { setIsLogin } from "../../redux/actions/roleAction";
import { useDispatch } from "react-redux";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import { useSelector } from "react-redux";

const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useRef(null);
  const [show, setShow] = useState(false);
  const { role } = useSelector((state) => state.roleReducer);

  const handleLogout = () => {
    setShow(false);
    toast.current.show({ severity: "success", summary: "Logout Successfully" });
    setTimeout(async () => {
      navigate("/");
      dispatch(setIsLogin(false));
    }, 1000);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        className="logout-modal"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="modal-title text-center">
          Are you sure you want to Logout?
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center">
          <Button
            variant="secondary"
            className="me-3 yes-btn-cls-add"
            onClick={() => handleLogout()}
          >
            Yes
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShow(false)}
            className="no-btn-cls-add"
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Toast ref={toast} />
      <section className="loop-app-project">
        <div className="sidebar-dark-primary">
          <div className="padding-less">
            <div className="side-navigation-bar sidebar">
              <div className="d-flex flex-column flex-shrink-0 sidebar-section">
                <ul className="nav nav-pills flex-column mb-auto">
                  <Nav className="nav-item">
                    <NavLink
                      to="/user-management"
                      className="nav-link link-body-emphasis"
                      aria-current="page"
                    >
                      User Management
                    </NavLink>
                    {role !== "Sub_Admin" && (
                      <NavLink
                        to="/role-management"
                        className="nav-link link-body-emphasis"
                      >
                        Role Management
                      </NavLink>
                    )}
                    <NavLink
                      to="/event-management"
                      className="nav-link link-body-emphasis"
                    >
                      Event Management
                    </NavLink>
                    <NavLink
                      to="/news-management"
                      className="nav-link link-body-emphasis"
                    >
                      News Management
                    </NavLink>
                    {role !== "Sub_Admin" && (
                      <NavLink
                        to="/membership-management"
                        className="nav-link link-body-emphasis"
                      >
                        Membership Management
                      </NavLink>
                    )}
                    <NavLink
                      to="/badges"
                      className="nav-link link-body-emphasis"
                    >
                      Badges
                    </NavLink>
                    <NavLink
                      to="/Sponsor"
                      className="nav-link link-body-emphasis"
                    >
                      Sponsor
                    </NavLink>
                    <NavLink
                      to="/specialities"
                      className="nav-link link-body-emphasis"
                    >
                      Specialities
                    </NavLink>
                    <NavLink
                      to="/voicetype"
                      className="nav-link link-body-emphasis"
                    >
                      Voice Type
                    </NavLink>
                    <NavLink
                      to="/voicelanguage"
                      className="nav-link link-body-emphasis"
                    >
                      Voice language
                    </NavLink>
                    <NavLink
                      to="/connectivity"
                      className="nav-link link-body-emphasis"
                    >
                      Connectivity
                    </NavLink>
                    <NavLink
                      to="/profile-setting"
                      className="nav-link link-body-emphasis"
                    >
                      Profile Settings
                    </NavLink>
                  </Nav>
                </ul>
              </div>
              <div className="proper-align-in">
                <div className="logout-btn-cls">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setShow(true)}
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sidebar;
